import styled from 'styled-components';

import Button from '@components/Button';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const IconButton = styled(Button)`
  position: relative;
  width: 36px !important;
  min-width: 36px !important;
  height: 36px !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: 0 12px;
  text-align: center;
  color: ${({ theme }) => theme.palette.grey1100};
`;
